import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { useEffect } from "react";
import LandingPage from "@/pages/LandingPage";
import HotelPilot from "@/pages/HotelPilot";
import AdminLogin from "@/pages/AdminLogin";
import AdminPanel from "@/pages/AdminPanel";
import AuthCallback from "@/pages/AuthCallback";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import ComeFunziona from "@/pages/ComeFunziona";
import Termini from "@/pages/Termini";
import Privacy from "@/pages/Privacy";
import NotFound from "@/pages/NotFound";
import HotelierRegister from "@/pages/HotelierRegister";
import HotelierLogin from "@/pages/HotelierLogin";
import HotelierDashboard from "@/pages/HotelierDashboard";
import Certificato from "@/pages/Certificato";
import Manifesto from "@/pages/Manifesto";
import FAQ from "@/pages/FAQ";
import { CookieBanner } from "@/components/CookieBanner";
import { StickyCountdownBar } from "@/components/StickyCountdownBar";
import { initAnalytics, trackPageView } from "@/lib/analytics";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    trackPageView(pathname);
  }, [pathname]);
  return null;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <ScrollToTop />
      <StickyCountdownBar />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/hotel-pilota" element={<HotelPilot />} />
        <Route path="/hotel/:hotelId" element={<HotelPilot />} />
        <Route path="/come-funziona" element={<ComeFunziona />} />
        <Route path="/termini" element={<Termini />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="/proponi" element={<HotelierRegister />} />
        <Route path="/hotelier-login" element={<HotelierLogin />} />
        <Route path="/hotelier/dashboard" element={<HotelierDashboard />} />
        <Route path="/certificato/:code" element={<Certificato />} />
        <Route path="/manifesto" element={<Manifesto />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <CookieBanner />
    </>
  );
}

export default function App() {
  useEffect(() => {
    initAnalytics();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#121212",
              color: "#ffffff",
              border: "1px solid #2a2a2a",
              borderRadius: "2px",
              fontFamily: "Manrope, sans-serif",
              letterSpacing: "0.02em",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}
